var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkLightCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4C11.163 4 4 11.163 4 20s7.163 16 16 16 16-7.163 16-16S28.837 4 20 4zm0 29.935c-7.656 0-13.935-6.197-13.935-13.935 0-7.656 6.197-13.935 13.935-13.935 7.656 0 13.935 6.197 13.935 13.935 0 7.656-6.197 13.935-13.935 13.935zm9.137-17.739l-11.643 11.55a.774.774 0 01-1.095-.004l-5.54-5.585a.774.774 0 01.004-1.095l.55-.545a.774.774 0 011.094.004l4.45 4.486 10.545-10.46a.774.774 0 011.095.005l.545.55a.773.773 0 01-.005 1.094z"
  })));
}
export default SvgCheckmarkLightCircle;